var _templateObject = _taggedTemplateLiteral(['\n  display: table;\n  width: 100%;\n'], ['\n  display: table;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: table-row;\n'], ['\n  display: table-row;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: table-cell;\n  padding-top: 8px;\n  padding-bottom: 8px;\n'], ['\n  display: table-cell;\n  padding-top: 8px;\n  padding-bottom: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 1.2rem;\n'], ['\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 1.2rem;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var Table = styled.div(_templateObject);
export var TableRow = styled.div(_templateObject2);
export var TableCell = styled.div(_templateObject3);
export var TableHeader = styled(TableCell)(_templateObject4);
//# sourceMappingURL=table.js.map
